import React from "react";
import { Box, Progress, Text } from "@chakra-ui/react";

type Props = {
    progress: number;        // 0-100
    isUploading: boolean;
    label?: string;
};

const UploadProgress: React.FC<Props> = ({
    progress,
    isUploading,
    label = "Uploading...",
}) => {
    if (!isUploading) return null;

    const pct = Math.max(0, Math.min(100, progress || 0));

    return (
        <Box mt={2}>
            <Text fontSize="sm" mb={1} color="teal.600">
                {label} {pct}%
            </Text>
            <Progress value={pct} size="sm" borderRadius="md" />
        </Box>
    );
};

export default UploadProgress;